import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { showModal } from '../../../actions/ModalActions';
import { createWeddingForRegistryAccountUser } from '../../../actions/WeddingActions';
import { signout } from '../../../actions/AuthActions';
import '../../../stylesheets/pages/preauth/components/FooterCtaSection.less';

class FooterCtaSection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onCtaClick = this.onCtaClick.bind(this);
  }

  onCtaClick() {
    const { userContext, openModal, onCreateWeddingAccount } = this.props;

    if (userContext.has_wedding_account) {
      browserHistory.push('/wedding/manage');
    } else if (userContext.has_registry) {
      onCreateWeddingAccount();
    } else if (!userContext.is_guest) {
      browserHistory.push('/wedding/onboard?product=WEDDING_WEBSITE');
    } else if (userContext.is_guest) {
      if (window.zolaNav && window.zolaNav.openSignupModal) {
        window.zolaNav.openSignupModal();
      } else {
        openModal('AUTH', { authState: 'signup', autoCreate: true }, { size: 'md' });
      }
    }
  }

  render() {
    const { heading, cta } = this.props; // onLogOut

    // let ctaText;
    // if (userContext.has_wedding_account) {
    //   ctaText = 'Log In';
    // } else if (userContext.has_registry) {
    //   ctaText = 'Get Started';
    // } else if (!userContext.is_guest) {
    //   ctaText = 'Get Started';
    // } else {
    //   ctaText = 'Sign Up';
    // }
    return (
      <div className="footer-cta-section text-center">
        <div>
          <h2>{ heading }</h2>
          <span className="lets-do-this hidden-xs">We&apos;ll make this fun and easy!</span>
          <button className="btn btn-primary btn-wide center-block footer-button" onClick={this.onCtaClick}>{cta ? `${cta}` : 'Get Started'}</button>
        </div>
      </div>
    );
  }
}

FooterCtaSection.propTypes = {
  openModal: PropTypes.func.isRequired,
  userContext: PropTypes.shape({}),
  onCreateWeddingAccount: PropTypes.func.isRequired,
  heading: PropTypes.string,
  cta: PropTypes.string,
};

const mapStateToProps = state => (
  {
    userContext: state.user.userContext,
    weddingAccount: state.wedding.account,
  }
);

const mapDispatchToProps = dispatch => (
  {
    openModal: (modalType, modalProps, modalOptions) => {
      dispatch(showModal(modalType, modalProps, modalOptions));
    },
    showVideo: () => {
      const video = { video: 'aBqthnJ08JQ', autoplay: true };
      dispatch(showModal('VIDEO', { video, className: 'iframe-responsive', hideClose: true }, { size: 'video' }));
    },
    onCreateWeddingAccount: () => dispatch(createWeddingForRegistryAccountUser()).then(() => browserHistory.push('/wedding/manage')),
    onLogOut: () => {
      dispatch(signout()).then(() => window.location.reload());
    }
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterCtaSection);



/** WEBPACK FOOTER **
 ** ./src/pages/preauth/components/FooterCtaSection.jsx
 **/